export const ETH_BLOCKS_PER_YEAR = 2390676 // (60 * 60 * 24 * 365.2422) / (13.2 sec/block)
export const KCC_BLOCKS_PER_YEAR = 10518975 // (60 * 60 * 24 * 365.2422) / 3
